<template>
  <div class="modal fade stick-up" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header clearfix text-left">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i class="pg-close fs-14"></i>
          </button>
          <h3 v-html="title"></h3>
          <p v-html="subtitle"></p>
        </div>
        <div class="modal-body">
          <slot name="body"></slot>
          <div class="row m-t-10 sm-m-t-10">
            <slot name="footer"></slot>            
          </div>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
</template>

<script>
  export default {
    name: 'Modal',
    props: {
      type: {
        type: String,
        default: 'stick-up'
      },
      title: {
        type: String,
        default: ''
      },
      subtitle: {
        type: String,
        default: ''
      }
    },
    methods: {
      show() {
        $(this.$el).modal('show');        
      },
      hide() {
        $(this.$el).modal('hide');
      }
    }
  }
</script>

<style>
  .modal-content .modal-body form {
    background: #fafafa;
    padding: 0 20px;
    margin-top: 10px;
  }

</style>


// WEBPACK FOOTER //
// modal.vue?00c73e7c